import {
    STEAM_UPDATE,
    STEAM_SET_USED_TICKET,
} from '../constants'

export function actionSteamSave(steam) {
    return {
        type: STEAM_UPDATE,
        payload: steam,
    }
}

export function actionSteamSetUsedTicket(usedTicket) {
    return {
        type: STEAM_SET_USED_TICKET,
        payload: usedTicket,
    }
}



// WEBPACK FOOTER //
// ./src/actions/steam.js